import { supabase } from './supabase';

// Get a specific restaurant by ID
export async function getRestaurant(restaurantId) {
  try {
    const { data, error } = await supabase
      .from('restaurants')
      .select('*')
      .eq('id', restaurantId)
      .single();

    if (error) {
      console.error('Error fetching restaurant:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error in getRestaurant:', error);
    throw error;
  }
}

// Get all restaurants owned by a user
export async function getUserRestaurants(userId) {
  try {
    const { data, error } = await supabase
      .from('restaurants')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching user restaurants:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Error in getUserRestaurants:', error);
    return [];
  }
}

// Get all menu categories for a restaurant
export async function getCategories(restaurantId) {
  try {
    // Update table name to match your schema
    const { data, error } = await supabase
      .from('categories') // This matches your schema
      .select('*')
      .eq('restaurant_id', restaurantId)
      .order('display_order', { ascending: true });

    if (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Error in getCategories:', error);
    return [];
  }
}

// Get all menu items for a restaurant, optionally filtered by category
export async function getMenuItems(restaurantId, categoryId = null) {
  try {
    let query = supabase
      .from('menu_items')
      .select('*')
      .eq('restaurant_id', restaurantId);

    if (categoryId) {
      query = query.eq('category_id', categoryId);
    }

    const { data, error } = await query.order('display_order', { ascending: true });

    if (error) {
      console.error('Error fetching menu items:', error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Error in getMenuItems:', error);
    return [];
  }
}

// Get the complete menu structure for a restaurant (categories with their menu items)
export async function getRestaurantMenu(restaurantId) {
  try {
    // First get all categories
    const { data: categories, error: categoriesError } = await supabase
      .from('categories')
      .select('*')
      .eq('restaurant_id', restaurantId)
      .order('display_order');
      
    if (categoriesError) throw categoriesError;
    
    // Then get all menu items for this restaurant
    const { data: menuItems, error: menuItemsError } = await supabase
      .from('menu_items')
      .select('*')
      .eq('restaurant_id', restaurantId);
      
    if (menuItemsError) throw menuItemsError;
    
    // Organize menu items by category
    const categoriesWithItems = categories.map(category => {
      // Add items that belong to this category
      const items = menuItems.filter(item => item.category_id === category.id);
      return {
        ...category,
        menu_items: items
      };
    });
    
    return categoriesWithItems;
  } catch (error) {
    console.error('Error in getRestaurantMenu:', error);
    throw error;
  }
}

// Create a new restaurant
export async function createRestaurant(restaurantData) {
  try {
    const { data: restaurant, error } = await supabase
      .from('restaurants')
      .insert([restaurantData])
      .select()
      .single();

    if (error) {
      console.error('Error creating restaurant:', error);
      throw error;
    }

    return restaurant;
  } catch (error) {
    console.error('Error in createRestaurant:', error);
    throw error;
  }
}